import React, { useEffect, useState } from "react";
import { Dropdown } from "semantic-ui-react";
import "./newProperty.css";
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "../../components/InputField";
import { ModalMessage } from "../../components/ModalConfirmAction";
import { baseUrl } from "../../../services/api";
import { listRealEstates } from "../../../services/api/real_estates";
import { getPropertieById } from "../../../services/api/properties";
import Spinner from "../../components/Spinner";
import { FaArrowLeft } from "react-icons/fa";
import { useProperty } from "../../../utils/PropertyContext";
import { formatCentsToBRL } from "../../../utils/formatMoney";
import { heicTo } from "heic-to";
import {
  ACCEPTED_IMAGE_FORMATS_MESSAGE,
  IMAGE_FILE_ACCEPT,
  buildImageOrder,
  createImagePreview,
  partitionImageFiles,
} from "../../../utils/imageFiles";

export default function NewProperty() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const propertyIdFromUrl = searchParams.get("propertyId");
  const { refetchProperties } = useProperty();
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [formDataFromIa, setFormDataFromIa] = useState([]);
  const [realEstates, setRealEstates] = useState([]);
  const [loading, setLoading] = useState(false);

  const [listaImagens, setListaImagens] = useState([]);
  const [draggedItemIndex, setDraggedItemIndex] = useState(null);

  const [, setRealEstateNameValue] = useState("");
  const [isLancamentoIa, setIsLancamentoIa] = useState(false);
  const [bairrosDisplayOptions, setBairrosDisplayOptions] = useState(
    [
      "Forte",
      "Boqueirão",
      "Guilhermina",
      "Aviação",
      "Tupi",
      "Ocian",
      "Mirim",
      "Maracanã",
      "Caiçara",
      "Vilamar",
      "Jardim Real",
      "Imperador",
      "Flórida",
      "Solemar",
      "Sítio do Campo",
      "Tude Bastos",
      "Jardim Glória",
      "Vila Sonia",
      "Vila Antártica",
      "Balneário Maxland",
      "Tupiry",
      "Anhanguera",
      "Quietude",
      "Nova Mirim",
      "Ribeirópolis",
      "Jardim Trevo",
      "Balneário Esmeralda",
      "Samambaia",
      "Parque das Américas",
      "Jardim Melvi",
      "Jardim Princesa",
      "Cidade das Crianças",
    ].map((b) => ({ key: b, text: b, value: b })),
  );

  const handleBairroAddition = (e, { value }) => {
    setBairrosDisplayOptions((prev) => [
      { key: value, text: value, value },
      ...prev,
    ]);
  };
  const handleBairroChange = (e, { value }) => {
    setFormData((prev) => ({ ...prev, bairro: value }));
  };

  const initialFormData = {
    id: "",
    dataCadastro: new Date().toISOString().split("T")[0],
    dataAlteracao: new Date().toISOString().split("T")[0],
    permuta: false,
    comissao: "",
    tipoImovel: "",
    dorms: "",
    banheiros: "",
    suites: "",
    garagens: "",
    area: "",
    statusImovel: "Venda",
    posicaoImovel: "",
    anoEntregaImovel: "",
    mesEntregaImovel: "",
    valor: "",
    valorFinanciamentoDireto: "",
    parcelasFinanciamentoDireto: "",
    info_condicao_financiamento: "",
    iptu: "",
    condominio: "",
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    nomeResidencial: "",
    bairro: "",
    cidade: "",
    estado: "",
    categoriaResponsavel: "",
    contatos: [],
    chaves: "",
    outrasInfo: "",
    caracteristicas: [],
    real_estate_id: null,
    financiamentoDireto: false,
    drivelinks: "",
    is_lancamento: false,
    has_full_leisure: false,
    has_pool: false,
    is_furnished: false,
    has_edicule: false,
    is_seafront: false,
    has_sea_view: false,
    is_near_beach: false,
  };

  const [formData, setFormData] = useState(initialFormData);

  const checkboxLabels = {
    has_full_leisure: "Lazer Completo",
    has_pool: "Piscina",
    is_furnished: "Mobiliado",
    has_edicule: "Com Edícula",
    is_seafront: "Frente ao Mar",
    has_sea_view: "Vista ao Mar",
    is_near_beach: "Próximo a Praia",
  };

  const bairrosOptions = bairrosDisplayOptions.map((b) => b.value);

  const meses = [
    { value: 1, text: "Janeiro" },
    { value: 2, text: "Fevereiro" },
    { value: 3, text: "Março" },
    { value: 4, text: "Abril" },
    { value: 5, text: "Maio" },
    { value: 6, text: "Junho" },
    { value: 7, text: "Julho" },
    { value: 8, text: "Agosto" },
    { value: 9, text: "Setembro" },
    { value: 10, text: "Outubro" },
    { value: 11, text: "Novembro" },
    { value: 12, text: "Dezembro" },
  ];

  const formatCommissionForDisplay = (apiValue) => {
    if (apiValue === null || apiValue === undefined || apiValue === "")
      return "";
    const v = String(apiValue).trim().toLowerCase();
    if (v === "0.04") return "4%";
    if (v === "0.05") return "5%";
    if (v === "0.06") return "6%";
    if (v === "4" || v === "4.0" || v === "4.00" || v === "4%") return "4%";
    if (v === "5" || v === "5.0" || v === "5.00" || v === "5%") return "5%";
    if (v === "6" || v === "6.0" || v === "6.00" || v === "6%") return "6%";
    if (v === "fifty") return "Fifty";
    return "";
  };

  const handleMoneyChange = (event) => {
    const { name, value } = event.target;
    let rawValue = value.replace(/\D/g, "");
    if (rawValue === "" || !rawValue) rawValue = "0";
    setFormData((prev) => ({ ...prev, [name]: rawValue }));
  };

  useEffect(() => {
    async function fetchRealEstatesData() {
      try {
        const response = await listRealEstates();
        setRealEstates(response || []);
      } catch (error) {
        console.error("Erro ao buscar imobiliárias:", error);
        setRealEstates([]);
      }
    }
    fetchRealEstatesData();
  }, []);

  useEffect(() => {
    const currentBairro = formData.bairro;
    if (currentBairro) {
      setBairrosDisplayOptions((prevOptions) => {
        const exists = prevOptions.some((opt) => opt.value === currentBairro);
        if (!exists) {
          return [
            { key: currentBairro, text: currentBairro, value: currentBairro },
            ...prevOptions,
          ];
        }
        return prevOptions;
      });
    }
  }, [formData.bairro]);

  useEffect(() => {
    async function loadPropertyData(id) {
      setLoading(true);
      try {
        const existingProperty = await getPropertieById(id);
        if (!existingProperty) {
          alert("Imóvel não encontrado.");
          navigate("/dashboard/adicionar-imovel/");
          return;
        }
        const contatosTratados = Array.isArray(existingProperty.contatos)
          ? existingProperty.contatos.filter((c) => c && (c.name || c.cel))
          : [];

        const existingImageUrls = Array.isArray(existingProperty.imagens)
          ? existingProperty.imagens.filter(
              (img) => typeof img === "string" && img.startsWith("http"),
            )
          : [];

        const formatadas = existingImageUrls.map((url, index) => ({
          id: `old-${index}-${Date.now()}`,
          type: "existing",
          url: url,
        }));
        setListaImagens(formatadas);

        const cleanValue = (value) => {
          if (value === null || value === undefined) return "0";
          const stringValue = String(value);
          const cleaned = stringValue.replace(/\D/g, "");
          return cleaned === "" ? "0" : cleaned;
        };

        setFormData((prev) => ({
          ...initialFormData,
          ...existingProperty,
          id: existingProperty.id || "",
          dataCadastro: existingProperty.dataCadastro
            ? new Date(existingProperty.dataCadastro)
                .toISOString()
                .split("T")[0]
            : prev.dataCadastro,
          dataAlteracao: new Date().toISOString().split("T")[0],
          permuta: !!existingProperty.permuta,
          financiamentoDireto:
            !!existingProperty.aceitaFinanciamento ||
            !!existingProperty.financiamentoDireto,
          is_lancamento: !!existingProperty.is_lancamento,
          comissao: formatCommissionForDisplay(existingProperty.comissao),
          real_estate_id:
            existingProperty.real_estate_id != null
              ? String(existingProperty.real_estate_id)
              : null,
          contatos: contatosTratados,
          valor: cleanValue(existingProperty.valor),
          iptu: cleanValue(existingProperty.iptu),
          condominio: cleanValue(existingProperty.condominio),
          valorFinanciamentoDireto: cleanValue(
            existingProperty.valorFinanciamentoDireto,
          ),
          info_condicao_financiamento:
            existingProperty.info_condicao_financiamento || "",
          drivelinks: (existingProperty.drivelinks || "")
            .replace(/[{}]/g, "")
            .trim(),
          has_full_leisure: !!existingProperty.has_full_leisure,
          has_pool: !!existingProperty.has_pool,
          is_furnished: !!existingProperty.is_furnished,
          has_edicule: !!existingProperty.has_edicule,
          is_seafront: !!existingProperty.is_seafront,
          has_sea_view: !!existingProperty.has_sea_view,
          is_near_beach: !!existingProperty.is_near_beach,
          mesEntregaImovel: existingProperty.mesEntregaImovel || "",
        }));
      } catch (error) {
        console.error("Erro ao buscar dados do imóvel:", error);
        alert("Não foi possível carregar os dados do imóvel.");
      } finally {
        setLoading(false);
      }
    }
    if (propertyIdFromUrl) {
      loadPropertyData(propertyIdFromUrl);
    } else {
      setFormData(initialFormData);
      setListaImagens([]);
      setRealEstateNameValue("");
    }
  }, [propertyIdFromUrl, navigate]);

  useEffect(() => {
    if (formData.real_estate_id && realEstates.length > 0) {
      const selected = realEstates.find(
        (re) => String(re.id) === String(formData.real_estate_id),
      );
      if (selected) {
        setRealEstateNameValue(selected.full_name || selected.name || "");
      }
    } else if (!formData.real_estate_id) {
      setRealEstateNameValue("");
    }
  }, [formData.real_estate_id, realEstates]);

  const semanticRealEstateOptions = (realEstates || [])
    .filter((re) => re.type !== "payer")
    .map((re) => ({
      key: re.id,
      value: re.id,
      text: `${re.full_name || re.name} - (${re.type})`,
    }));

  const handleDropdownChange = (event, data) => {
    const selectedId = data.value;
    const selectedRealEstate = realEstates.find((re) => re.id === selectedId);
    let finalCategory = "";
    if (selectedRealEstate) {
      finalCategory = selectedRealEstate.type;
      if (finalCategory === "Imobiliária")
        finalCategory = "Imobiliária/Parceria";
    }
    setFormData((prev) => ({
      ...prev,
      real_estate_id: selectedId,
      categoriaResponsavel: finalCategory,
    }));
    setRealEstateNameValue(
      selectedRealEstate?.full_name || selectedRealEstate?.name || "",
    );
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const finalValue = type === "checkbox" ? checked : value;

    setFormData((prev) => {
      let newData = { ...prev, [name]: finalValue };

      if (name === "statusImovel" && finalValue === "Revenda") {
        newData.is_lancamento = false;
      }

      if (name === "posicaoImovel" && finalValue !== "Em construção") {
        newData.mesEntregaImovel = "";
        newData.anoEntregaImovel = "";
      }

      return newData;
    });
  };

  const handleAddContact = () => {
    setFormData((prev) => ({
      ...prev,
      contatos: [...(prev.contatos || []), { name: "", cel: "" }],
    }));
  };

  const handleRemoveContact = (index) => {
    setFormData((prev) => ({
      ...prev,
      contatos: prev.contatos.filter((_, i) => i !== index),
    }));
  };

  const handleContactChange = (index, event) => {
    const { name, value } = event.target;
    const keyToUpdate = name === "nome" ? "name" : "cel";
    let finalValue = value;
    if (keyToUpdate === "cel") {
      finalValue = String(value).replace(/\D/g, "");
    }
    setFormData((prev) => {
      const updatedContacts = (prev.contatos || []).map((contact, i) => {
        if (i === index) return { ...contact, [keyToUpdate]: finalValue };
        return contact;
      });
      return { ...prev, contatos: updatedContacts };
    });
  };

  const adicionarNovasImagens = async (files) => {
    const { accepted, rejected } = partitionImageFiles(files);
    if (rejected.length > 0) {
      alert(`Alguns arquivos não são imagens suportadas. ${ACCEPTED_IMAGE_FORMATS_MESSAGE}`);
    }
    if (accepted.length === 0) return;

    setLoading(true);

    try {
      const novasImagensFormatadas = await Promise.all(
        accepted.map(async (file, i) => {
          let arquivoProcessado = file;
          const fileName = file.name.toLowerCase();

          if (
            fileName.endsWith(".heic") ||
            fileName.endsWith(".heif") ||
            file.type === "image/heic"
          ) {
            try {
              const convertedBlob = await heicTo({
                blob: file,
                type: "image/jpeg",
                quality: 0.8,
              });

              const finalBlob = Array.isArray(convertedBlob)
                ? convertedBlob[0]
                : convertedBlob;

              arquivoProcessado = new File(
                [finalBlob],
                file.name.replace(/\.(heic|heif)$/i, ".jpg"),
                { type: "image/jpeg" },
              );
            } catch (err) {
              console.error("Erro ao converter HEIC para JPEG:", err);
            }
          }

          return {
            id: `new-${Date.now()}-${i}`,
            type: "new",
            file: arquivoProcessado,
            url: createImagePreview(arquivoProcessado),
          };
        }),
      );

      setListaImagens((prev) => [...prev, ...novasImagensFormatadas]);
    } finally {
      setLoading(false);
    }
  };

  const handleImgUpload = (e) =>
    adicionarNovasImagens(Array.from(e.target.files));

  const handleDropImg = (e) => {
    e.preventDefault();
    adicionarNovasImagens(Array.from(e.dataTransfer.files));
  };

  const handleDragOverImg = (e) => e.preventDefault();

  const removeImage = (idToRemove) => {
    setListaImagens((prev) => prev.filter((img) => img.id !== idToRemove));
  };

  const handleDragStartItem = (index) => {
    setDraggedItemIndex(index);
  };

  const handleDragEnterItem = (index) => {
    if (draggedItemIndex === null || draggedItemIndex === index) return;
    setListaImagens((prev) => {
      const newList = [...prev];
      const draggedItem = newList[draggedItemIndex];
      newList.splice(draggedItemIndex, 1);
      newList.splice(index, 0, draggedItem);
      setDraggedItemIndex(index);
      return newList;
    });
  };

  const handleDragEndItem = () => {
    setDraggedItemIndex(null);
  };

  const handlePdfUpload = (e) =>
    setFormDataFromIa((prev) => [...prev, ...Array.from(e.target.files)]);

  const handleDropPdf = (e) => {
    e.preventDefault();
    setFormDataFromIa((prev) => [...prev, ...Array.from(e.dataTransfer.files)]);
  };

  const handleDragOverPdf = (e) => e.preventDefault();

  const removePdf = (indexToRemove) =>
    setFormDataFromIa((prev) => prev.filter((_, idx) => idx !== indexToRemove));

  const handleIaSubmit = async (event) => {
    event.preventDefault();
    if (!formData.real_estate_id) {
      alert("Selecione uma imobiliária válida da lista para o envio via IA.");
      return;
    }
    if (!formDataFromIa.length) {
      alert("Adicione ao menos um arquivo PDF para análise.");
      return;
    }
    const FILE_SIZE_LIMIT_MB = 25;
    const FILE_SIZE_LIMIT_BYTES = FILE_SIZE_LIMIT_MB * 1024 * 1024;
    const totalSize = formDataFromIa.reduce((acc, file) => acc + file.size, 0);
    if (totalSize > FILE_SIZE_LIMIT_BYTES) {
      const userConfirmed = window.confirm(
        "ATENÇÃO: ARQUIVOS GRANDES DETECTADOS\n\n" +
          "O tamanho total dos arquivos excede 25 MB. Por causa disso, é muito provável que esta tela exiba uma mensagem DE SUCESSO após alguns minutos.\n\n" +
          "Se os imóveis não aparecerem na liberação NÃO SE PREOCUPE!\n" +
          "Seus arquivos FORAM RECEBIDOS e serão processados em segundo plano pelo servidor (mesmo com um eventual erro na tela).\n\n" +
          "Deseja continuar com o envio mesmo assim?",
      );
      if (!userConfirmed) return;
    }
    setLoading(true);
    const formDataToSend = new FormData();
    const userId = localStorage.getItem("currentUserId");
    if (userId) formDataToSend.append("created_by", userId);
    formDataToSend.append("real_estate_id", formData.real_estate_id);

    if (formData.categoriaResponsavel) {
      formDataToSend.append(
        "categoriaResponsavel",
        formData.categoriaResponsavel,
      );
    }
    formDataToSend.append("is_lancamento", isLancamentoIa ? 1 : 0);
    formDataFromIa.forEach((pdfFile) =>
      formDataToSend.append("files", pdfFile),
    );

    try {
      const response = await fetch(`${baseUrl}/create-properties`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        body: formDataToSend,
      });
      const data = await response.json();
      if (!response.ok)
        throw new Error(data.detail || data.error || "Erro desconhecido");
      await refetchProperties();
      setShowMessageModal(true);
    } catch (error) {
      console.error("Falha ao enviar PDF para IA:", error);
      setShowMessageModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleManualSubmit = async (event) => {
    event.preventDefault();
    const requiredFields = {
      tipoImovel: "Tipo de Imóvel",
      comissao: "Comissão (%)",
      real_estate_id: "Responsável (Imobiliária/Construtora)",
    };

    for (const [field, label] of Object.entries(requiredFields)) {
      if (!formData[field] && formData[field] !== 0) {
        alert(`O campo '${label}' é obrigatório.`);
        return;
      }
    }

    if (!formData.real_estate_id) {
      alert(
        "O campo 'Responsável (Imobiliária/Construtora)' é obrigatório e deve ser selecionado da lista.",
      );
      return;
    }

    if (formData.posicaoImovel === "Em construção") {
      if (!formData.anoEntregaImovel) {
        alert(
          "O campo 'Ano de Entrega' é obrigatório para imóveis em construção.",
        );
        return;
      }
    }

    setLoading(true);
    const formDataToSend = new FormData();
    const isUpdating = !!propertyIdFromUrl;

    if (!isUpdating) {
      const userId = localStorage.getItem("currentUserId");
      if (userId) formDataToSend.append("created_by", userId);
    }

    const zones = {
      zona_1_2: [
        "Forte",
        "Boqueirão",
        "Guilhermina",
        "Aviação",
        "Tupi",
        "Vila Assunção",
        "Ocian",
        "Mirim",
        "Maracanã",
        "Caiçara",
        "Vilamar",
        "Imperador",
        "Jd. Real",
        "Jardim Real",
        "Flórida",
        "Solemar",
      ],
      zona_3: [
        "Tude Bastos",
        "Sitio do Campo",
        "Sítio do Campo",
        "Jardim Glória",
        "Vila Sonia",
        "Vila Antártica",
        "Balneário Maxland",
        "Tupiry",
        "Quietude",
        "Anhanguera",
        "Nova Mirim",
        "Ribeirópolis",
        "Jardim Trevo",
        "Esmeralda",
        "Balneário Esmeralda",
        "Samambaia",
        "Parque das Américas",
        "Melvi",
        "Jardim Melvi",
        "Jardim Princesa",
        "Cidade das Crianças",
      ],
    };

    let calculatedZone = "Indefinida";
    const selectedBairro = formData.bairro;

    if (selectedBairro) {
      if (zones.zona_1_2.includes(selectedBairro)) {
        calculatedZone = "zona_1_2";
      } else if (zones.zona_3.includes(selectedBairro)) {
        calculatedZone = "zona3";
      }
    }
    formDataToSend.append("zona", calculatedZone);

    const dataToProcess = { ...formData };
    if (dataToProcess.comissao === "Fifty") dataToProcess.comissao = 999;
    if (dataToProcess.drivelinks)
      dataToProcess.drivelinks = String(dataToProcess.drivelinks)
        .replace(/[{}]/g, "")
        .trim();

    if (dataToProcess.posicaoImovel !== "Em construção") {
      dataToProcess.mesEntregaImovel = "null";
      dataToProcess.anoEntregaImovel = "null";
    }

    for (const key in dataToProcess) {
      const moneyFields = [
        "valor",
        "iptu",
        "condominio",
        "valorFinanciamentoDireto",
      ];
      if (moneyFields.includes(key)) {
        const valueFromState = dataToProcess[key] || "0";
        formDataToSend.append(key, valueFromState);
      } else if (key !== "imagens" && key !== "contatos") {
        formDataToSend.append(key, dataToProcess[key] ?? "");
      }
    }

    if (formData.contatos && formData.contatos.length > 0) {
      formData.contatos.forEach((contact) => {
        formDataToSend.append("contatos", JSON.stringify(contact));
      });
    }
    formDataToSend.append("is_lancamento", formData.is_lancamento);

    const imagensExistentesToSubmit = listaImagens
      .filter((img) => img.type === "existing")
      .map((img) => img.url);
    const novosArquivosToSubmit = listaImagens
      .filter((img) => img.type === "new")
      .map((img) => img.file);

    imagensExistentesToSubmit.forEach((url) =>
      formDataToSend.append("imagens", url),
    );
    novosArquivosToSubmit.forEach((file) =>
      formDataToSend.append("new_image_files", file),
    );

    if (
      isUpdating &&
      imagensExistentesToSubmit.length === 0
    ) {
      formDataToSend.append("imagens", "");
    }

    const ordemImagens = buildImageOrder(listaImagens);
    formDataToSend.append("ordem_imagens", JSON.stringify(ordemImagens));

    const token = localStorage.getItem("token");
    const url = isUpdating
      ? `${baseUrl}/properties/${propertyIdFromUrl}`
      : `${baseUrl}/properties/`;
    const method = isUpdating ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method,
        headers: { Authorization: `Bearer ${token}` },
        body: formDataToSend,
      });
      const data = await response.json();
      if (!response.ok)
        throw new Error(data.detail || data.error || "Erro ao salvar imóvel");
      await refetchProperties();
      setShowMessageModal(true);
    } catch (error) {
      console.error("Falha na submissão manual:", error);
      alert(`Falha ao salvar imóvel: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const maskPhone = (value) => {
    if (!value) return "";
    const digitsOnly = value.replace(/\D/g, "");
    const limitedDigits = digitsOnly.slice(0, 11);
    let maskedValue = limitedDigits.replace(/^(\d{2})/, "($1)");
    if (limitedDigits.length > 2) {
      maskedValue = limitedDigits.replace(/^(\d{2})(\d{5})/, "($1) $2");
    }
    if (limitedDigits.length > 7) {
      maskedValue = limitedDigits.replace(
        /^(\d{2})(\d{5})(\d{4})/,
        "($1) $2-$3",
      );
    }
    return maskedValue;
  };

  useEffect(() => {
    const cepValue = formData.cep
      ? String(formData.cep).replace(/\D/g, "")
      : "";
    if (cepValue.length === 8) {
      const fetchAddress = async () => {
        try {
          const response = await fetch(
            `https://viacep.com.br/ws/${cepValue}/json/`,
          );
          const data = await response.json();
          if (!data.erro) {
            const returnedBairro = data.bairro || "";
            const isBairroInList = bairrosOptions.includes(returnedBairro);
            setFormData((prevFormData) => ({
              ...prevFormData,
              logradouro: data.logradouro || "",
              bairro: isBairroInList ? returnedBairro : prevFormData.bairro,
              cidade: data.localidade || "",
              estado: data.uf || "",
            }));
          }
        } catch (error) {
          console.error("Erro ao buscar dados do CEP:", error);
        }
      };
      fetchAddress();
    }
  }, [formData.cep]);

  const handleArrowReturn = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/dashboard/liberacao/");
    }
  };

  const showLancamentoCheckbox = formData.statusImovel !== "Revenda";

  return (
    <>
      {propertyIdFromUrl && (
        <button className="bt-arrow-return" onClick={handleArrowReturn}>
          <FaArrowLeft />
        </button>
      )}

      {loading && (
        <div className="loading-overlay">
          <Spinner />
        </div>
      )}

      <h1 className="page-title">
        {propertyIdFromUrl
          ? `EDITAR IMÓVEL (ID: ${propertyIdFromUrl})`
          : "CADASTRO DE IMÓVEL"}
      </h1>

      {!propertyIdFromUrl && (
        <form className="form-property" onSubmit={handleIaSubmit}>
          <section>
            <h2>ENVIO DE IMÓVEIS COM LEITURA IA</h2>

            <div className="container-section-form">
              <p>
                Faça abaixo o envio dos arquivos no formato PDF para leitura das
                informações com Inteligência Artificial:
              </p>

              <label
                htmlFor="fileInputPdfIa"
                className="drop-area"
                onDrop={handleDropPdf}
                onDragOver={handleDragOverPdf}
              >
                <input
                  type="file"
                  id="fileInputPdfIa"
                  multiple
                  accept="application/pdf"
                  onChange={handlePdfUpload}
                  style={{ display: "none" }}
                />
                SELECIONE UM ARQUIVO OU ARRASTE E SOLTE (PDF)
              </label>

              <div className="pdf-preview">
                {formDataFromIa.map((pdf, index) => (
                  <div key={index} className="pdf-container">
                    <span>{pdf.name}</span>

                    <button
                      type="button"
                      onClick={() => removePdf(index)}
                      className="btn-remove-file"
                    >
                      x
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <Dropdown
              fluid
              placeholder="Responsável (Imobiliária | Construtora | Investidor | Corretor(a))"
              search
              selection
              clearable
              options={semanticRealEstateOptions}
              onChange={handleDropdownChange}
              value={formData.real_estate_id}
              style={{ marginBottom: "1em" }}
            />

            <div
              className="input-space-checkbox"
              style={{ marginBottom: "1em" }}
            >
              <input
                type="checkbox"
                name="is_lancamento_ia"
                id="is_lancamento_ia"
                checked={isLancamentoIa}
                onChange={(e) => setIsLancamentoIa(e.target.checked)}
              />
              <label htmlFor="is_lancamento_ia">Marcar como Lançamento</label>
            </div>

            <div className="container-bt-post">
              <button
                type="submit"
                disabled={
                  loading ||
                  !formData.real_estate_id ||
                  formDataFromIa.length === 0
                }
              >
                {loading ? "ENVIANDO..." : "ENVIAR PDF PARA LEITURA IA"}
              </button>
            </div>
          </section>
        </form>
      )}

      <form className="form-property" onSubmit={handleManualSubmit}>
        <section>
          <h2>INFORMAÇÕES DO IMÓVEL (CADASTRO MANUAL)</h2>

          <div className="container-section-form">
            <h3>Imagens do Imóvel</h3>

            <label
              htmlFor="fileInputImg"
              className="drop-area"
              onDrop={handleDropImg}
              onDragOver={handleDragOverImg}
            >
              <input
                type="file"
                id="fileInputImg"
                multiple
                accept={IMAGE_FILE_ACCEPT}
                onChange={handleImgUpload}
                style={{ display: "none" }}
              />
              SELECIONE IMAGENS OU ARRASTE E SOLTE
              <small>{ACCEPTED_IMAGE_FORMATS_MESSAGE}</small>
            </label>

            <div className="image-preview">
              {listaImagens.map((item, index) => (
                <div
                  key={item.id}
                  className={`image-container ${draggedItemIndex === index ? "dragging" : ""}`}
                  draggable
                  onDragStart={() => handleDragStartItem(index)}
                  onDragEnter={() => handleDragEnterItem(index)}
                  onDragEnd={handleDragEndItem}
                  onDragOver={(e) => e.preventDefault()}
                  title="Arraste para reordenar"
                >
                  <img
                    src={item.url}
                    alt={`Preview ${index + 1}`}
                    className="preview-img"
                  />

                  <button
                    type="button"
                    onClick={() => removeImage(item.id)}
                    className="btn-remove-file"
                  >
                    x
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="container-section-form">
            <h3>Características do Imóvel</h3>

            <div className="container-input">
              <InputField
                ident="Tipo de Imóvel"
                name="tipoImovel"
                inputType="select"
                options={[
                  "",
                  "Casa",
                  "Apartamento",
                  "Casa em Condomínio",
                  "Galpão",
                  "Terreno",
                  "Sala Comercial",
                  "Ponto Comercial",
                ]}
                value={formData.tipoImovel}
                onChange={handleInputChange}
                required={!propertyIdFromUrl}
                placeholder="Selecione"
              />

              <InputField
                ident="Nome do Residencial"
                name="nomeResidencial"
                inputType="text"
                value={formData.nomeResidencial}
                placeholder="Nome do Residencial"
                onChange={handleInputChange}
              />

              <InputField
                ident="Dorms."
                name="dorms"
                inputType="select"
                options={["", 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                value={formData.dorms}
                onChange={handleInputChange}
                placeholder="Qtd."
              />

              <InputField
                ident="WC"
                name="banheiros"
                inputType="select"
                options={["", 0, 1, 2, 3, 4, 5]}
                value={formData.banheiros}
                onChange={handleInputChange}
                placeholder="Qtd."
              />

              <InputField
                ident="Suítes"
                name="suites"
                inputType="select"
                options={["", 0, 1, 2, 3, 4, 5]}
                value={formData.suites}
                onChange={handleInputChange}
                placeholder="Qtd."
              />

              <InputField
                ident="Garagens"
                name="garagens"
                inputType="select"
                options={["", 0, 1, 2, 3, 4, 5]}
                value={formData.garagens}
                onChange={handleInputChange}
                placeholder="Qtd."
              />

              <InputField
                ident="Área (m²)"
                name="area"
                inputType="text"
                value={formData.area}
                placeholder="Ex: 120.50"
                onChange={handleInputChange}
              />

              <InputField
                ident="Comissão (%)"
                name="comissao"
                inputType="select"
                options={["4%", "5%", "6%", "Fifty"]}
                value={formatCommissionForDisplay(formData.comissao)}
                onChange={handleInputChange}
                required={!propertyIdFromUrl}
                placeholder="Selecione"
              />

              <InputField
                className="input-space-default"
                ident="Status do Imóvel"
                inputType="select"
                options={["Venda", "Revenda", "Locação"]}
                value={formData.statusImovel || "Venda"}
                name="statusImovel"
                onChange={handleInputChange}
              />

              <InputField
                className="input-space-default"
                ident="Posição do Imóvel"
                inputType="select"
                options={["Entregue", "Em construção"]}
                value={formData.posicaoImovel}
                name="posicaoImovel"
                onChange={handleInputChange}
              />

              {formData.posicaoImovel === "Em construção" && (
                <>
                  <div className="input-space-default">
                    <label>Mês de Entrega</label>
                    <select
                      value={formData.mesEntregaImovel}
                      name="mesEntregaImovel"
                      onChange={handleInputChange}
                    >
                      <option value=""></option>
                      {meses.map((m) => (
                        <option key={m.value} value={m.value}>
                          {m.text}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="input-space-default">
                    <label>
                      Ano de Entrega<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      value={formData.anoEntregaImovel}
                      name="anoEntregaImovel"
                      onChange={handleInputChange}
                    >
                      <option value=""></option>
                      {Array.from(
                        { length: 25 },
                        (_, i) => new Date().getFullYear() + i,
                      ).map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </div>
          </div>

          {showLancamentoCheckbox && (
            <div className="container-checkbox-lancamento">
              <div className="input-space-checkbox">
                <input
                  type="checkbox"
                  name="is_lancamento"
                  id="is_lancamento_manual"
                  checked={!!formData.is_lancamento}
                  onChange={handleInputChange}
                />
                <label htmlFor="is_lancamento_manual">Lançamento</label>
              </div>
            </div>
          )}

          <div className="container-section-form">
            <h3>Valores do Imóvel</h3>

            <div className="container-input">
              <InputField
                ident="Valor do Imóvel"
                name="valor"
                inputType="text"
                value={formatCentsToBRL(formData.valor)}
                placeholder="R$ 0,00"
                onChange={handleMoneyChange}
              />

              <InputField
                ident="IPTU"
                name="iptu"
                inputType="text"
                value={formatCentsToBRL(formData.iptu)}
                placeholder="R$ 0,00"
                onChange={handleMoneyChange}
              />

              <InputField
                ident="Condomínio"
                name="condominio"
                inputType="text"
                value={formatCentsToBRL(formData.condominio)}
                placeholder="R$ 0,00"
                onChange={handleMoneyChange}
              />
            </div>
          </div>

          <div className="container-section-form">
            <h3>Métodos de Pagamento</h3>

            <div className="container-input-checkbox-data">
              <div className="input-space-checkbox">
                <input
                  type="checkbox"
                  name="permuta"
                  id="permuta"
                  checked={!!formData.permuta}
                  onChange={handleInputChange}
                />

                <label htmlFor="permuta">Permuta</label>
              </div>

              <div className="input-space-checkbox">
                <input
                  type="checkbox"
                  name="financiamentoDireto"
                  id="financiamentoDiretoCB"
                  checked={!!formData.financiamentoDireto}
                  onChange={handleInputChange}
                />

                <label htmlFor="financiamentoDiretoCB">
                  Financiamento Direto
                </label>
              </div>
            </div>

            {!!formData.financiamentoDireto && (
              <div className="container-input">
                <InputField
                  ident="Valor com Financiamento Direto"
                  name="valorFinanciamentoDireto"
                  inputType="text"
                  value={formatCentsToBRL(formData.valorFinanciamentoDireto)}
                  placeholder="R$ 0,00"
                  onChange={handleMoneyChange}
                />

                <InputField
                  ident="Qtd. Parcelas (FD)"
                  name="parcelasFinanciamentoDireto"
                  inputType="number"
                  value={formData.parcelasFinanciamentoDireto}
                  placeholder="N°"
                  onChange={handleInputChange}
                />

                <InputField
                  ident="Info. Adicional Financiamento"
                  name="info_condicao_financiamento"
                  inputType="textarea"
                  className="input-space-large"
                  value={formData.info_condicao_financiamento}
                  placeholder="Detalhes sobre a condição de financiamento"
                  onChange={handleInputChange}
                />
              </div>
            )}
          </div>

          <div className="container-section-form">
            <h3>Endereço do Imóvel</h3>

            <div className="container-input">
              <InputField
                ident="Cep"
                name="cep"
                inputType="text"
                value={formData.cep}
                placeholder="00000-000"
                onChange={handleInputChange}
                maxLength={9}
              />

              <InputField
                ident="Endereço"
                name="logradouro"
                inputType="text"
                value={formData.logradouro}
                placeholder="Logradouro"
                onChange={handleInputChange}
              />

              <InputField
                ident="Número"
                name="numero"
                inputType="text"
                value={formData.numero}
                placeholder="N°"
                onChange={handleInputChange}
              />

              <InputField
                ident="Complemento"
                name="complemento"
                inputType="text"
                value={formData.complemento}
                placeholder="Complemento"
                onChange={handleInputChange}
              />

              <div className="input-space-default">
                <label>Bairro:</label>
                <Dropdown
                  options={bairrosDisplayOptions}
                  placeholder="Selecione ou digite..."
                  search
                  selection
                  fluid
                  allowAdditions
                  value={formData.bairro}
                  onAddItem={handleBairroAddition}
                  onChange={handleBairroChange}
                  noResultsMessage="Nenhum bairro encontrado. Digite para adicionar."
                  additionLabel="Adicionar novo bairro: "
                  required
                />
              </div>

              <InputField
                ident="Cidade"
                name="cidade"
                inputType="text"
                value={formData.cidade}
                placeholder="Cidade"
                onChange={handleInputChange}
              />

              <InputField
                ident="Estado"
                name="estado"
                inputType="text"
                value={formData.estado}
                placeholder="UF"
                maxLength={2}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="container-section-form">
            <h3>Informações do Responsável pelo Imóvel</h3>

            <div className="container-input">
              <Dropdown
                placeholder="Responsável (Imobiliária | Construtora | Investidor | Corretor(a))"
                fluid
                search
                selection
                clearable
                options={semanticRealEstateOptions}
                onChange={handleDropdownChange}
                value={formData.real_estate_id}
              />

              <div className="container-contacts">
                {(formData.contatos || []).map((contact, index) => (
                  <div key={index} className="contact-entry">
                    <InputField
                      ident={`Nome Contato ${index + 1}`}
                      name="nome"
                      inputType="text"
                      value={contact.name || ""}
                      placeholder="Nome"
                      onChange={(e) => handleContactChange(index, e)}
                    />

                    <InputField
                      ident={`Celular Contato ${index + 1}`}
                      name="cel"
                      inputType="tel"
                      value={maskPhone(contact.cel || "")}
                      placeholder="Celular"
                      onChange={(e) => handleContactChange(index, e)}
                      maxLength={15}
                    />

                    <button
                      type="button"
                      onClick={() => handleRemoveContact(index)}
                      className="btn-remove-contact"
                    >
                      Remover
                    </button>
                  </div>
                ))}

                <button
                  type="button"
                  onClick={handleAddContact}
                  className="bt-add-contact"
                >
                  Adicionar Contato
                </button>
              </div>
            </div>
          </div>

          <div className="container-section-form">
            <h3>Informações Diversas</h3>

            <div className="container-input other-format">
              <InputField
                ident="Localização das Chaves"
                name="chaves"
                inputType="text"
                className="input-space-large"
                value={formData.chaves}
                placeholder="Onde pegar as chaves"
                onChange={handleInputChange}
              />

              <InputField
                ident="Link da Pasta no Drive"
                name="drivelinks"
                inputType="text"
                className="input-space-large"
                value={formData.drivelinks}
                placeholder="Cole o link da pasta do Drive aqui"
                onChange={handleInputChange}
              />

              <InputField
                ident="Outras informações"
                name="outrasInfo"
                inputType="textarea"
                className="input-space-large"
                value={formData.outrasInfo}
                placeholder="Detalhes adicionais (não inclua lazer, use as caixas abaixo)"
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="container-section-form">
            <h3>Características de Lazer</h3>

            <div className="container-input-checkbox-data">
              {Object.keys(checkboxLabels).map((key) => (
                <div className="input-space-checkbox" key={key}>
                  <input
                    id={`checkbox-${key}`}
                    type="checkbox"
                    name={key}
                    checked={!!formData[key]}
                    onChange={handleInputChange}
                  />

                  <label htmlFor={`checkbox-${key}`}>
                    {checkboxLabels[key]}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="container-bt-post">
            <button type="submit" disabled={loading}>
              {loading
                ? "SALVANDO..."
                : propertyIdFromUrl
                  ? "ATUALIZAR IMÓVEL"
                  : "CADASTRAR IMÓVEL"}
            </button>
          </div>
        </section>
      </form>

      {showMessageModal && (
        <ModalMessage
          buttonConfirmAction={() => {
            setShowMessageModal(false);
            navigate(propertyIdFromUrl ? "/dashboard" : "/dashboard/liberacao");
          }}
          isOpen={showMessageModal}
          title="SUCESSO"
          onClose={() => {
            setShowMessageModal(false);
            navigate(propertyIdFromUrl ? "/dashboard" : "/dashboard/liberacao");
          }}
          descriptionAction="Operação realizada com sucesso!"
        />
      )}
    </>
  );
}
